<template>
  <div class="groups">
    <group-list-component></group-list-component>
  </div>
</template>

<script>
import GroupListComponent from "@/components/GroupListComponent";

export default {
  components: {
    GroupListComponent,
  },
};
</script>
